"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M13.7448 10.5882C13.3003 10.5882 12.9388 10.2716 12.9388 9.88233C12.9388 9.49304 13.3003 9.17645 13.7448 9.17645C14.1894 9.17645 14.5509 9.49304 14.5509 9.88233C14.5509 10.2716 14.1894 10.5882 13.7448 10.5882ZM11.3589 3.88379H13.5199L14.5564 6.00144H11.3589V3.88379ZM5.48177 10.5882C5.03724 10.5882 4.67574 10.2716 4.67574 9.88233C4.67574 9.49304 5.03724 9.17645 5.48177 9.17645C5.92589 9.17645 6.28779 9.49304 6.28779 9.88233C6.28779 10.2716 5.92589 10.5882 5.48177 10.5882ZM15.0016 3.32612C14.7477 2.80729 14.1645 2.47059 13.5197 2.47059H11.3587V1.41176C11.3587 0.632118 10.6369 0 9.74667 0H2.49242C1.60217 0 0.880371 0.632118 0.880371 1.41176V8.47059C0.880371 9.25024 1.60217 9.88235 2.49242 9.88235H3.06349C3.06349 11.052 4.14599 12 5.48158 12C6.81676 12 7.89966 11.052 7.89966 9.88235H10.5527H11.3261C11.3261 11.052 12.4086 12 13.7442 12C15.0797 12 16.1622 11.052 16.1622 9.88235H16.1949C16.6398 9.88235 17.0009 9.56647 17.0009 9.17647V7.41176L15.0016 3.32612Z",
  fill: "currentColor"
}), 'DeliveryDefaultFilled', {
  viewBox: '0 0 20 20'
});

exports.default = _default;